import React from 'react';
import { ClassValue } from 'classnames/types';
import styles from './TagText.module.scss';
import Typography, { TypographyProps, SupportedTagName } from '../Typography';
import { ArrayElementType } from '../../../types/utils/ArrayElementType';

type TagTextProps<T extends SupportedTagName> = {
  size?: SupportedTagTextSize;
} & Omit<TypographyProps<T>, 'font' | 'uppercase' | 'fontWeight'>;

function TagText<T extends SupportedTagName>({
  tagName,
  size = 'md',
  className,
  children,
  ...props
}: TagTextProps<T>) {
  const classNames: ClassValue = [
    styles[`tagText__size_${size.toLowerCase()}`],
    className,
  ];

  return (
    <Typography
      {...props}
      tagName={tagName as SupportedTagName} // this circumvents some weird ts problem
      font="teliasans"
      className={classNames}
      uppercase
      fontWeight="bold"
    >
      {children}
    </Typography>
  );
}

export const supportedTagTextSizes = ['md', 'sm'] as const;

export type SupportedTagTextSize = ArrayElementType<
  typeof supportedTagTextSizes
>;

export default TagText;
